import { render, staticRenderFns } from "./UserArgePopup.vue?vue&type=template&id=b28849a2&scoped=true&"
import script from "./UserArgePopup.vue?vue&type=script&lang=js&"
export * from "./UserArgePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28849a2",
  null
  
)

export default component.exports